import { NgModule } from '@angular/core';

//******************************************************************************
//  Import Core Components
//******************************************************************************
import { CoreImports } from '~/core/classes/imports/core.imports';

//******************************************************************************
//  Import External Components
//******************************************************************************
import { ExternalImports } from '~/classes/imports/external.imports';

//******************************************************************************
//  Services
//******************************************************************************

//******************************************************************************
//  Pages
//******************************************************************************
import { HomeComponent } from '~/pages/home/home.component';
import { RecordDetailComponent } from '~/pages/record-detail/record-detail.component';
import { DataTableComponent } from '~/components/data-table/data-table.component';

//******************************************************************************
//  Pipes
//******************************************************************************
import { SafePipe } from '~/core/pipes/safe.pipe';

const components: any[] = [
    HomeComponent,
    RecordDetailComponent,
    DataTableComponent,
];

const services: any[] = [
];

@NgModule({
    imports: [
        CoreImports,
        ExternalImports,
    ],
    declarations: [
        ...components,
        SafePipe,
    ],
    exports: [
        ...components,
    ],
    providers: [
        ...services,
    ],
})

export class AppImports { }
